// extracted by mini-css-extract-plugin
export default {"container":"FreeDaysPaywallStep_container__DO0iN","title":"FreeDaysPaywallStep_title__QAanX","titleAlt":"FreeDaysPaywallStep_titleAlt__FBsCD"};